var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-container',{attrs:{"page":_vm.page}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Create New Reaffirming Study Phase")]),_c('sr-reaffirm-study-form',{attrs:{"item":_vm.item,"project":_vm.project,"showNoExist":_vm.showNoExist}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }